/**
 * Слой звонка над навигатором: плашка «Вернуться к звонку» и владелец сессии звонка
 * (аудит удобства 2026-10-04, P0-5).
 *
 * <p><b>Почему плашка сдвигает экраны, а не лежит поверх.</b> Поверх она закрывала бы шапку чата
 * — имя собеседника и кнопки звонка. Поэтому навигатор стоит под ней, внутри своего
 * `SafeAreaProvider`: тот меряет отступы от собственного края, и, пока плашка видна, верхний
 * отступ под строку состояния у экранов становится нулевым — его уже взяла плашка. Шапка
 * native-stack сама перестаёт добавлять отступ (`headerTopInsetEnabled` выводится из него же),
 * так что двойного зазора нет ни на Android, ни на iOS.
 *
 * <p>Структура дерева от видимости плашки не зависит: навигатор всегда на одном месте, иначе
 * появление плашки пересоздавало бы весь стек экранов.
 */
import React, { Suspense } from 'react';
import { StyleSheet, View } from 'react-native';
import { initialWindowMetrics, SafeAreaProvider } from 'react-native-safe-area-context';
import { useCallSessionMeta } from './callSessionHooks';
import { ReturnToCallBar } from './ReturnToCallBar';

const CallSessionRunner = React.lazy(() => import('./CallSessionRunner'));

function ActiveCallHost(): React.ReactElement | null {
  const meta = useCallSessionMeta();
  if (!meta) return null;
  return (
    <Suspense fallback={null}>
      {/* key — номер сессии: новый звонок получает новый экземпляр хука звонка. */}
      <CallSessionRunner key={meta.key} meta={meta} />
    </Suspense>
  );
}

export function ActiveCallLayer({ children }: { children: React.ReactNode }): React.ReactElement {
  return (
    <View style={styles.root}>
      <ReturnToCallBar />
      <SafeAreaProvider initialMetrics={initialWindowMetrics} style={styles.root}>
        {children}
      </SafeAreaProvider>
      <ActiveCallHost />
    </View>
  );
}

const styles = StyleSheet.create({
  root: { flex: 1 },
});
